import { ReactComponent as Lighthouse } from "shared/assets/lighthouse.svg";

const NoDataTableImage = () => <Lighthouse />;
export default NoDataTableImage;
